import React, { FunctionComponent } from 'react';
import { Grid, Typography, makeStyles } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import StandardMarkdownNoMargin from '@modules/ui/markdown/components/StandardMarkdownNoMargin';
import OpenCloudAPIObject from '../../../utils/interfaces/OpenCloudAPIObject';
import { objectsID } from '../constants/openCloudConstants';
import ObjectContainer from '../../objects/components/ObjectContainer';

const useStyles = makeStyles()(() => ({
  description: {
    marginTop: 24,
  },
}));

export interface OpenCloudObjectsContainerProps {
  objects: OpenCloudAPIObject[];
}

const OpenCloudObjectsContainer: FunctionComponent<
  React.PropsWithChildren<OpenCloudObjectsContainerProps>
> = ({ objects }) => {
  const { translate } = useTranslation();
  const {
    classes: { description: descriptionStyle },
  } = useStyles();
  const description = translate('Label.ObjectsDescription');

  if (objects.length === 0) {
    return null;
  }

  return (
    <Grid container direction='column'>
      <Typography variant='h2' component='h2' id={objectsID}>
        {translate('Label.Objects')}
      </Typography>
      {description && (
        <StandardMarkdownNoMargin className={descriptionStyle}>
          {description}
        </StandardMarkdownNoMargin>
      )}
      {objects.map((object) => {
        return <ObjectContainer key={object.name} object={object} />;
      })}
    </Grid>
  );
};

export default OpenCloudObjectsContainer;
